module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('section', {
    staticClass: "wrapper departure section"
  }, [_h('div', {
    staticClass: "inner"
  }, [_h('h1', ["1. Departure"]), " ", _h('scrollfire', {
    attrs: {
      "initial": ""
    },
    on: {
      "entered": _vm.detectLocation
    }
  }), " ", _h('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.detectingLocation) ? _h('h2', ["Finding your location, please wait... ", _h('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x fa-fw"
  })]) : _h('form', {
    attrs: {
      "method": "post",
      "action": "#"
    }
  }, [_h('div', {
    staticClass: "field"
  }, [_h('label', {
    attrs: {
      "for": "city"
    }
  }, ["City"]), " ", _h('input', {
    attrs: {
      "type": "text",
      "name": "city",
      "id": "city",
      "value": "Berlin"
    }
  })]), " ", _h('div', {
    staticClass: "field"
  }, [_h('label', {
    attrs: {
      "for": "country"
    }
  }, ["Country"]), " ", _h('input', {
    attrs: {
      "type": "text",
      "name": "country",
      "id": "country",
      "value": "Germany"
    }
  })]), " ", _h('ul', {
    staticClass: "actions"
  }, [_h('li', [_h('input', {
    attrs: {
      "type": "submit",
      "value": "Next"
    }
  })])])]), " "])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f256f12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Departure.vue
// module id = 41
// module chunks = 1